import { render } from "./ourServicesComponent.vue?vue&type=template&id=08fd2bb5"
import script from "./ourServicesComponent.vue?vue&type=script&lang=js"
export * from "./ourServicesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__